module.exports = __webpack_public_path__ + "static/media/pedestrian-crossing.a3e64d3f.png";